const footNav = [
  { title: "分区导航", links: [
    { label: "今日热议榜", href: "#heat" },
    { label: "风云人物争议", href: "#people" },
    { label: "同学圈避雷名单", href: "#avoid" },
    { label: "学生干部争议", href: "#cadre" },
    { label: "社团内部瓜", href: "#club" },
    { label: "口碑翻车回放", href: "#flip" },
  ] },
  { title: "本站指南", links: [
    { label: "热议话题", href: "#topic" },
    { label: "圈内守则", href: "#guard" },
    { label: "投稿入口", href: "#report" },
    { label: "当事人申诉", href: "#report" },
    { label: "回到顶部", href: "#top" },
  ] },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-primary-200">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.2fr_0.9fr_0.9fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="relative flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-accent-950">
                <i className="ri-bug-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-extrabold tracking-tight text-background-50">校园黑料</span>
            </div>
            <p className="mt-3 text-xs leading-relaxed text-primary-300">
              校园风云人物黑料、同学圈避雷名单、社交黑瓜、学生干部争议与社团内部瓜——把散落在同学圈里的口碑线索整理成一份底账，帮你认清身边人，社交不踩雷。
            </p>
            <p className="mt-3 inline-flex items-center gap-1.5 rounded-md bg-primary-900/60 px-2.5 py-1 text-[11px] text-primary-300">
              <i className="ri-information-line text-accent-400"></i> 本页面为演示站，所涉内容均为虚构
            </p>
          </div>
          {footNav.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-extrabold tracking-widest text-accent-300">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-primary-100 transition hover:text-accent-300">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start gap-2 border-t border-primary-800 pt-6 text-[11px] leading-relaxed text-primary-400 sm:flex-row sm:justify-between">
          <p>
            立场声明：本站只做可核实信息的客观整理，反对人身攻击、网络暴力与无证据造谣。如涉及本人或他人权益，请通过申诉通道处理。
          </p>
          <span className="shrink-0 whitespace-nowrap">© {new Date().getFullYear()} 校园黑料 · 同学圈避雷中心</span>
        </div>
      </div>
    </footer>
  );
}